module.exports = __webpack_public_path__ + "img/project_4.eede9470.png";